module.exports = __webpack_public_path__ + "static/img/8.403bced.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/8.png
// module id = jXtg
// module chunks = 0